import React from "react";

/**
 * @component CloseIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <CloseIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const CloseIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="CloseIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.613 6.21l.094.083L12 10.585l4.293-4.292a1 1 0 011.497 1.32l-.083.094L13.415 12l4.292 4.293a1 1 0 01-1.32 1.497l-.094-.083L12 13.415l-4.293 4.292a1 1 0 01-1.497-1.32l.083-.094L10.585 12 6.293 7.707a1 1 0 011.32-1.497z"
      />
    </svg>
  )
);
CloseIcon.displayName = "CloseIcon";
export default CloseIcon;
